export default __webpack_public_path__ + "static/media/logo-md.997404c7.jpg";